import { Link } from 'react-router-dom';
import Header from '../../../components/feature/Header';

export default function FrontLoaderPage() {
  return (
    <div className="min-h-screen bg-white">
      <Header />

      {/* Breadcrumb */}
      <section className="bg-gray-100 py-4">
        <div className="max-w-7xl mx-auto">
          <div className="flex items-center gap-2 text-sm">
            <Link to="/" className="text-[#dc3545] hover:underline">HOME</Link>
            <span>/</span>
            <span className="text-gray-600">FRONT LOADER</span>
          </div>
        </div>
      </section>

      {/* Main Content */}
      <div className="max-w-7xl mx-auto px-4 py-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          {/* Left Column - Images and Video */}
          <div className="space-y-6">
            <div className="bg-white rounded-lg overflow-hidden shadow-md">
              <img
                              src="/images/CAAGF_01.jpg"
                alt="Add A Grapple Front Loader"
                className="w-full h-auto"
              />
            </div>
            
          </div>

          {/* Right Column - Product Info */}
          <div className="bg-white rounded-lg p-8 shadow-md">
           
            <h1 className="text-3xl font-bold text-[#333333] mb-4">FRONT LOADER</h1>
            <h4 className="text-lg text-[#666666] mb-2">Model: 222440</h4>
            <h4 className="text-lg text-[#666666] mb-6">Weight: 387 lbs</h4>

            <h2 className="text-2xl font-bold text-[#333333] mb-4">
              Convert An Existing Bucket Into A "CONTRACTOR" Grapple Bucket!
            </h2>

            <div className="space-y-4 text-[#666666] mb-6">
              <p>
                The "Contractor" Add A Grapple Front Loader is designed for tractors over 50hp. The curved tines allow for a wider grip and easy release of material. The tine gussets follow the entire contour of the tines for added strength. Two welded cylinders with cylinder guards and plumbing is included. See our Grapple Spec Sheet and Add A Grapple Selector below to choose the correct Add A Grapple for your bucket.
              </p>
            </div>

            <hr className="my-6" />

            {/* Features Accordion */}
            <div className="mb-6">
              <details className="group" open>
                <summary className="flex justify-between items-center cursor-pointer list-none font-bold text-lg text-[#333333] py-3 border-b">
                  FEATURES
                  <i className="ri-arrow-down-s-line text-2xl group-open:rotate-180 transition-transform"></i>
                </summary>
                <ul className="mt-4 space-y-2 text-[#666666] list-disc list-inside">
                  <li>39″ Grapple Opening</li>
                  <li>Converts Existing Bucket into a Grapple Bucket</li>
                  <li>Fits Buckets 68″ to 90″ in Width</li>
                  <li>Fully Plumbed with Pioneer Couplers and Hose Guards</li>
                  <li>Pins and Boss' with eight grease zerks</li>
                </ul>
              </details>
            </div>

            {/* CTA Buttons */}
            <div className="space-y-4">
              <a
                href="/contact"
                className="block w-full bg-[#dc3545] hover:bg-[#c82333] text-white text-center py-3 px-6 font-bold rounded transition-colors"
              >
                Call Us Now
              </a>
             
              
            </div>
          </div>
        </div>

      

        {/* Disclaimer */}
        <div className="mt-12 bg-white rounded-lg p-8 shadow-md text-center">
          <h3 className="text-xl font-bold text-[#dc3545] mb-4">SOLVING TREE & BRUSH PROBLEMS SINCE 1992!</h3>
          <p className="text-[#666666]">
            All products have been carefully manufactured and tested. Should our product prove defective, or appear to be, please discontinue use immediately and contact us. Not responsible for any damage or claims beyond the selling price of the product. No returns allowed without express written consent of company.
          </p>
        </div>
      </div>

     
    </div>
  );
}
